var _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadioUncheckedIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 18.5,
    height: 18.5,
    rx: 9.25,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 18.5,
    height: 18.5,
    rx: 9.25,
    stroke: "#DCDCDE",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioUncheckedIcon);
export default __webpack_public_path__ + "static/media/radioUncheckedIcon.6d477d8d8eeb48b5269bd261104157bb.svg";
export { ForwardRef as ReactComponent };